<section class="metrics-section">
  <div class="row section-header-row">
    <div class="col-12">
      @if (my_company_product_cards().length > 0) {
        <p class="section-subtitle">Incluye métricas generales del producto y tus métricas personales en este producto.</p>
      } @else {
        <p class="section-subtitle">Métricas generales del producto.</p>
      }
    </div>
  </div>

  @if (has_company_product_metrics()) {
    <div class="company-product-group">
      <div class="company-product-group-chip">
        <img class="company-product-group-logo" [src]="company_product_logo_url()" [alt]="company_product_name()" />
        <span>{{ company_product_name() }}</span>
      </div>

      <div class="kpi-grid">
        @for (companyProductCard of company_product_cards(); track companyProductCard.id) {
          <button
            type="button"
            (click)="openKpiCardPreviewDialog(companyProductCard.rawData)"
            class="kpi-grid-card"
            [matTooltip]="companyProductCard.tooltip"
            matTooltipPosition="below"
            matTooltipShowDelay="500"
          >
            <div class="kpi-grid-card-leading">
              <span class="kpi-dot" [style.background-color]="companyProductCard.statusColor"></span>
              <span class="kpi-grid-card-title">{{ companyProductCard.metricName }}</span>
            </div>
            <div class="kpi-grid-card-trailing">
              <mat-icon class="kpi-eye-icon">visibility</mat-icon>
            </div>
          </button>
        }
      </div>

      <div class="kpi-grid my-company-product-grid">
        @for (companyProductCard of my_company_product_cards(); track companyProductCard.id) {
          <button
            type="button"
            (click)="openKpiCardPreviewDialog(companyProductCard.rawData)"
            class="kpi-grid-card"
            [matTooltip]="companyProductCard.tooltip"
            matTooltipPosition="below"
            matTooltipShowDelay="500"
          >
            <div class="kpi-grid-card-leading">
              <span class="kpi-dot" [style.background-color]="companyProductCard.statusColor"></span>
              <span class="kpi-grid-card-title">{{ companyProductCard.metricName }}</span>
            </div>
            <div class="kpi-grid-card-trailing">
              <mat-icon class="kpi-eye-icon">visibility</mat-icon>
            </div>
          </button>
        }
      </div>
    </div>
  } @else {
    <p class="section-subtitle">Sin métricas internas de producto para este periodo.</p>
  }
</section>
